import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = ["src"];
import { ref, onMounted } from 'vue';
import axios from 'axios';
// 响应式数据类型声明
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-swipe',
    setup: function (__props) {
        var _this = this;
        var list = ref([]);
        // 点击处理
        var handleClick = function (item) {
            window.location.href = item.link;
        };
        // 获取轮播数据
        var getSwiperList = function () { return __awaiter(_this, void 0, Promise, function () {
            var data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios({
                                url: '/swiperList',
                                method: 'get'
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        list.value = data.result;
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('获取轮播图数据失败:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // 生命周期钩子
        onMounted(function () {
            getSwiperList();
        });
        return function (_ctx, _cache) {
            var _component_van_swipe_item = _resolveComponent("van-swipe-item");
            var _component_van_swipe = _resolveComponent("van-swipe");
            var _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createBlock(_component_van_swipe, {
                class: "my-swipe",
                autoplay: 3000,
                "indicator-color": "white"
            }, {
                default: _withCtx(function () { return [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item) {
                        return _withDirectives((_openBlock(), _createBlock(_component_van_swipe_item, {
                            key: item.imgSrc,
                            onClick: function ($event) { return (handleClick(item)); },
                            class: "swipe"
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("img", {
                                    src: item.imgSrc,
                                    alt: "欢迎来到哔哩哔哩"
                                }, null, 8, _hoisted_1)
                            ]; }),
                            _: 2
                        }, 1032, ["onClick"])), [
                            [_directive_lazy, item]
                        ]);
                    }), 128))
                ]; }),
                _: 1
            }));
        };
    }
});
